import FileUploadInputs from "pages/QuestionPage/questionCreation/FileUploadInputs/FileUploadInputs";

export default FileUploadInputs;
